<template>
    <div class="smart-cat-wrapper">
        <div v-if="foundProductLinks.length" class="smart-cat__nav">
            <div class="btn-sm mr-1" :class="scrollProductCounter ? 'btn btn-primary' : 'btn-secondary'" @click="scrollPrevProductIntoView">Prev</div>
            <div class="product-number-wrapper">
                <small>product number</small>
                <span class="text-white">{{ selectedPartNumber }}</span>
                <span class="text-white">{{ scrollProductCounter + 1 }} of {{foundProductLinks.length}}</span>
            </div>
            <div class="btn-sm ml-1" :class="scrollProductCounter === foundProductLinks.length-1 ? 'btn-secondary' : 'btn btn-primary'" @click="scrollNextProductIntoView">Next</div>
        </div>
        <div v-if="loading" class="loading-page">
            <div class="spinner-container">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div v-if="!loading" class="smart-cat" v-html="manufacturerCatHTML" ref="smartCat"></div>
    </div>
</template>

<script>
    import { ManufacturerService, api } from '@/services'
    import { extractProdData } from "../modules/helpers";
    // console.log('document', document)
    // document.onreadystatechange = function () {
    //     console.log(document)
    //     // if (document.readyState === 'interactive') {
    //     //     initApplication();
    //     // }
    // }
    // window.addEventListener('DOMContentLoaded', (event) => {
    //     console.log('DOM fully loaded and parsed');
    // })
    
    export default {
        name: "SmartCatalog",
        data: () => {
            return {
                manufacturerCatHTML: null,
                selectedPartNumber: null,
                foundProductLinks: [],
                scrollProductCounter: 0,
                loading: true,
            }
        },
        props: {
          manufacturerId: {
              type: Number,
          },
          manufacturerCode: {
              type: String
          }
        },
        methods: {
            scrollFirstProductIntoView(){
                this.foundProductLinks[this.scrollProductCounter].scrollIntoView();
                this.foundProductLinks[this.scrollProductCounter].firstChild.style.backgroundColor = 'rgba(255,0,0,.3)';
            },
            scrollNextProductIntoView(){
                if (this.scrollProductCounter === this.foundProductLinks.length - 1) {
                    // this.$store.dispatch('ADD_NOTIFICATION', { text: 'End of Products Found', type: 'error' });
                    return;
                }
                console.log('prduct link', this.foundProductLinks[this.scrollProductCounter])

                this.foundProductLinks[this.scrollProductCounter].firstChild.style.backgroundColor = 'transparent';
                this.scrollProductCounter++;
                this.foundProductLinks[this.scrollProductCounter].firstChild.style.backgroundColor = 'rgba(255,0,0,.3)';
                this.foundProductLinks[this.scrollProductCounter].scrollIntoView();
            },
            scrollPrevProductIntoView(){
                if (this.scrollProductCounter === 0) {
                    // this.$store.dispatch('ADD_NOTIFICATION', { text: 'Beginning of Products Found', type: 'error' });
                    return;
                }

                this.foundProductLinks[this.scrollProductCounter].firstChild.style.backgroundColor = 'transparent';
                this.scrollProductCounter--;
                this.foundProductLinks[this.scrollProductCounter].firstChild.style.backgroundColor = 'rgba(255,0,0,.3)';
                this.foundProductLinks[this.scrollProductCounter].scrollIntoView();
            },
            setupPartNumberFilter(product){
               this.selectedPartNumber = product.PartNumber;
            },
            locateProductsByPartNumber(){
                console.log('this.to Caps', this.selectedPartNumber.toUpperCase(), this.selectedPartNumber.toLowerCase())
               let allProductLinks = this.getProductLinks();
               let foundProductLinks = allProductLinks.filter(pl => extractProdData(pl.href).PartNumber === this.selectedPartNumber|| extractProdData(pl.href).PartNumber === this.selectedPartNumber.toLowerCase() || extractProdData(pl.href).PartNumber === this.selectedPartNumber.toUpperCase()); // return extractedLinkPartNumber === 'V0287.0001';
            //    let foundProductLinks = allProductLinks.filter(pl => extractProdData(pl.href).PartNumber === 'V0287.0001'); // return extractedLinkPartNumber === 'V0287.0001';
            //    foundProductLinks.forEach(l => {
            //        l.firstChild.style.backgroundColor = 'rgba(255,0,0,.3)'
            //     }); //  TODO: fix product number highlighting
               this.foundProductLinks = foundProductLinks;

               if (this.foundProductLinks.length > 0){
                  this.scrollFirstProductIntoView();
               } else {
                  this.$store.dispatch('ADD_NOTIFICATION', { text: 'No Products Found', type: 'error' });
               }
            },
            getSmartCatalog(){
                ManufacturerService.getSmartCat(this.manufacturerId).then(res => {
                    this.getHtmlAsString(res);
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'No Smart Catalog Found', type: 'error'});
                })
            },
            getHtmlAsString(src){
                api.getFullUrl(src).then(res => {
                    this.manufacturerCatHTML = res;
                    console.log('res cat loaded')
                }).catch(err => {
                    console.error(err);
                })
            },
            getProductLinks(){
                let links = this.$refs.smartCat.querySelectorAll('a');
                let regex = new RegExp('http://www.dentacad.com/product', 'g');
                let productLinks = [...links].filter(({href}) => href.match(regex));
                return productLinks;
            }
        },
        mounted(){
            this.getSmartCatalog();
        },
        watch: {
            manufacturerCatHTML: function(newVal,oldVal){
                    // setTimeout(() => {
                    //     this.loading = false
                    // }, 1000)
                    this.loading = false;
                    if (oldVal !== null) return;
                    this.$nextTick(() => {
                        let productLinks = this.getProductLinks();
                        productLinks.map(pl => {
                            pl.addEventListener('click', e => {
                                e.preventDefault();
                                this.$emit('productClick', { productHref: pl.href },this.manufacturerId)
                            });
                        });
                        if (this.selectedPartNumber !== null) this.locateProductsByPartNumber();
                    });
                }

        }
    }
</script>

<style scoped lang="scss">
    .loading-page{
        width: 100vw;
        height: 100vh;
        background-color: $ss-grey;
        // position:fixed;
        // top: 0%;
        // left: 0%;
        // -webkit-transform: translate(-50%, -50%);
        // -moz-transform: translate(-50%, -50%);
        // -ms-transform: translate(-50%, -50%);
        // -o-transform: translate(-50%, -50%);
        // transform: translate(-50%, -50%);
        opacity: .75; 
    }
    // .loading-modal {
    //     position: fixed;
    //     top: 50%;
    //     left: 50%;
    //     -webkit-transform: translate(-50%, -50%);
    //     -moz-transform: translate(-50%, -50%);
    //     -ms-transform: translate(-50%, -50%);
    //     -o-transform: translate(-50%, -50%);
    //     transform: translate(-50%, -50%);
    //     background-color: $ss-grey;
    //     opacity: .75;
    //     width: 100%;
    //     height: 100%;
    //     z-index: 12000;
    // }
    .spinner-container {
        text-align: center;
        padding-top: 50vh;
        padding-right: 10vw;
    }
    .spinner-border {
        color: $primary;
    }
    .smart-cat {
        width: 90vw;
        height: 80vh;

        &__nav {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 5px;
            margin-top: -90px;
            background: grey;

            .product-number-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: $white;

                small {
                    text-transform: uppercase;
                }
                span {
                    font-size: 1.1rem;
                }
                margin-left:  10px;
                margin-right: 10px;
            }
         }
    }
</style>
